import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React, { Component } from 'react';
import firebase from 'firebase';
import Modal from 'react-modal';
import ModalTipos from './ModalTipos';
import Alert from 'react-s-alert';
import store from '../../store';
import copyright from '../../img/copyright-gray.png';
import { sendLog } from '../../util'

const database = firebase.database();

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		transform: 'translate(-50%, -50%)',
		width: '450px',
		height: '550px',

	}
};

class TiposVehiculos extends Component {

	constructor(props) {

		super(props)
		this.state = {
			tipos: [],
			isActive: false,
			key: '',
			tipo: '',
			estado: ''

		}

		this.tiposVehiculos = database.ref().child('Tipos_Vehiculos');
		this.handleClick = this.handleClick.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.ocultarMenu = this.ocultarMenu.bind(this);
		this.handleClickAlerta = this.handleClickAlerta.bind(this);
		this.handleClickClose = this.handleClickClose.bind(this);


		this.AlertaContenido = ({
			id,
			classNames,
			styles,
			message,
			customFields,
			handleClose,
		}) => {
			const handleConfirm = () => {
				sendLog({ tipo: 'tipo_vehiculo_editado' });

				this.handleSubmit();
				Alert.close(id);
				this.setState({
					template: false
				})
			}
			return (
				<div className={classNames} id={id} style={styles}>
					<div className='s-alert-box-inner'>
						{message}
					</div>
					<br />
					<br />
					<button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
					<button className="customButton btn btn-default btn-alerts btn-m-r" onClick={this.handleClickClose}>Cancelar</button>
					<span className='s-alert-close' onClick={handleClose}></span>
				</div>
			);
		}


	}


	handleClickAlerta(event) {
		this.setState({
			template: true

		})
		const customerName = 'Acacya';
		Alert.success('¿Deseas confirmar los cambios?', {
			position: 'top-right',
			timeout: 'none',
			customFields: {
				customerName: customerName
			}
		});

		event.preventDefault();
	}

	handleClickClose() {
		Alert.closeAll();
	}


	componentDidMount() {

		this.tiposVehiculos.on('value', this.gotData, this.errData);
	}

	componentWillMount() {



	}

	gotData = (data) => {

		let newTipos = [];

		if (data.val() !== null) {

			let tipo = data.val();
			let keys = Object.keys(tipo);

			for (let i = 0; i < keys.length; i++) {

				let k = keys[i];

				newTipos.push({
					key: k,
					tipo: tipo[k].tipo,
					estado: tipo[k].estado
				})
			}
			this.setState({ tipos: newTipos });

		}

	}
	errData = (err) => {

		console.log(err);

	}

	imgFormatter(cell, row) {

		return <button className="btn btn-success btn-sm" onClick={() => { this.handleClick(row) }} >Editar</button>;
	}


	handleClick(row) {

		this.setState({
			key: row.key,
			tipo: row.tipo,
			estado: row.estado


		})

		this.toggleModal();
	}


	toggleModal() {

		this.setState({
			isActive: !this.state.isActive
		})
	}

	handleSubmit() {

		let tipo = this.tipo.value;
		let estado = this.estado.value;


		database.ref().child('Tipos_Vehiculos').orderByChild('tipo').equalTo(tipo).once("value").then(snapshot => {

			if (!snapshot.exists() || this.state.tipo === tipo) {

				database.ref().child('Tipos_Vehiculos').child(this.state.key).update({

					tipo: tipo,
					estado: estado

				})

				sendLog({ tipo: 'tipo_vehiculo_editado', informacion_extra: { tipo_vehiculo: this.state.key } });
				Alert.success('Datos actualizados correctamente', {
					effect: 'genie',
					position: 'bottom-right',
					timeout: 2000
				});

				this.toggleModal();

			}
			else {

				Alert.warning('El tipo de vehiculos a ingresar ya existe', {
					effect: 'genie',
					position: 'bottom-right',
					timeout: 2000
				});


			}
		});


	}


	ocultarMenu() {


		store.dispatch({

			type: 'STATE_MOSTRAR',
			mostrar: 'noMostrar'
		})
	}



	render() {

		return (


			<div className="tipos_vehiculos container" onClick={this.ocultarMenu}>
				{this.state.template ? <Alert timeout='none' contentTemplate={this.AlertaContenido} /> : <Alert stack={{ limit: 3 }} html={true} />}
				<ModalTipos />
				<BootstrapTable data={this.state.tipos}
					ref='table'
					pagination={true}
					search={true} searchPlaceholder="Buscar"
					hover
				>
					<TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
					<TableHeaderColumn dataField='tipo' dataSort={true}  >Tipo</TableHeaderColumn>
					<TableHeaderColumn dataField='estado' dataSort={true} dataAlign='center'>Estado</TableHeaderColumn>
					<TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={this.imgFormatter.bind(this)}>Editar</TableHeaderColumn>
				</BootstrapTable>

				<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal} style={customStyles} >


					<form method="POST" action="" onSubmit={this.handleClickAlerta}>

						<center><h3>Editar tipo</h3></center>
						<hr />

						<div className="form-group">
							<label htmlFor="tipo">Tipo de Vehiculo</label>
							<input type="text" name="tipo" className="form-control" placeholder="Tipo de vehiculo"
								ref={input => { this.tipo = input }}
								defaultValue={this.state.tipo}
								required autoComplete="off"
							/>
						</div>



						<div className="form-group">
							<label htmlFor="estado">Estado:</label>
							<select className="form-control" name="estado"
								ref={input => { this.estado = input; }}
								defaultValue={this.state.estado}
							>
								<option>Activo</option>
								<option>Inactivo</option>
							</select>
						</div>



						<hr />
						<button className="btn btn-primary buttons" type="submit" >Guardar</button>
					</form>
					<button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
				</Modal>

				<footer className="footer-pg mt-auto py-3" style={{ width: '100%' }}>
					<div className="container">
					<div className="row">
						<div className="col-md-4 col-sm-4">
						</div>
						<div className="col-sm">
						<img src={copyright} />
						</div>
					</div>
					</div>
				</footer>
			</div>

		);
	}
}

export default TiposVehiculos;


// WEBPACK FOOTER //
// ./src/Components/Vehiculos/TiposVehiculos.js